export const WALLTYPE: Array<{ id: string; name: string }> = [{ id: 'otherWallType', name: 'Other Wall Type' }];

export const CABINETSTYPE: Array<{ id: string; name: string }> = [{ id: 'cabinets', name: 'Cabinets' }];

export const DISPOSE: Array<{ id: string; name: string }> = [
  { id: 'yes', name: 'Yes' },
  { id: 'no', name: 'No' },
];

export const FLOOR_CUTS: Array<{ id: string; name: string }> = [
  { id: "2'", name: "2'" },
  { id: "4'", name: "4'" },
];

export const LOCATION: Array<{ id: string; name: string }> = [
  { id: 'wall', name: 'Wall' },
  { id: 'ceiling', name: 'Ceiling' },
  { id: 'floor', name: 'Floor' },
];

export const CLEAN: Array<{ id: string; name: string }> = [
  { id: 'standard', name: 'Standard' },
  { id: 'heavy', name: 'Heavy' },
];
